<template>
  <span class="tooltip" :class="getBrowserInfo">
    <i class="icon" :class="iconName ? iconName : `icon--info-${iconSize}`"
      @mouseenter="showText = true"
      @mouseleave="showText = false"></i>
      <ui-tooltip v-show="showText || forceShowText"
                  ref="tooltip"
                  :style="tooltipStyle"
                  :arrowBottom="bindedArrowBottom"
                  :arrowLeft="arrowLeft"
                  :arrowTop="bindedArrowTop"
                  :arrowRight="arrowRight"
                  :arrowRightSide="arrowRightSide"
                  :arrowLeftSide="arrowLeftSide"
                  :arrowCenter="arrowCenter">
      <slot/>
    </ui-tooltip>
  </span>
</template>

<script>
import UiTooltip from './UiTooltip'
import { browserInfo } from '@/libs/utils'

export default {
  name: 'UiIconTooltip',
  components: {
    UiTooltip
  },
  props: {
    iconName: {
      type: String
    },
    arrowRightSide: {
      type: Boolean,
      default: false
    },
    arrowLeftSide: {
      type: Boolean,
      default: false
    },
    arrowBottom: {
      type: Boolean,
      default: false
    },
    arrowLeft: {
      type: Boolean,
      default: false
    },
    arrowTop: {
      type: Boolean,
      default: false
    },
    arrowRight: {
      type: Boolean,
      default: false
    },
    arrowCenter: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: 'small'
    },
    forceShowText: {
      type: Boolean,
      default: false
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showText: false,
      bindedArrowTop: this.arrowTop,
      bindedArrowBottom: this.arrowBottom
    }
  },
  watch: {
    /**
     * 현재 Position에 따라 툴팁이 나타나는 방향 결정
     */
    showText (newValue, oldValue) {
      if (this.control) {
        return null
      } else {
        const y = this.$el.getBoundingClientRect().top
        if (y < 300) {
          this.bindedArrowTop = true
          this.bindedArrowBottom = false
        } else {
          this.bindedArrowTop = false
          this.bindedArrowBottom = true
        }
      }
    }
  },
  computed: {
    tooltipStyle () {
      const isLeft = !this.arrowRight && !this.arrowCenter
      const isBottom = !this.bindedArrowTop
      const yOffset = ['normal', 'alert'].includes(this.iconSize) ? 4 : 0
      const xOffset = ['normal', 'alert'].includes(this.iconSize) ? 2 : 0
      let result

      if (this.arrowRightSide || this.arrowLeftSide) {
        result = {}
      } else {
        result = {
          'z-index': 15,
          top: !isBottom ? `${27 + yOffset}px` : 'auto',
          bottom: isBottom ? `${27 + yOffset}px` : 'auto'
        }
      }

      if (this.arrowCenter) {
        result.transform = 'translateX(-50%)'
        result.marginLeft = `${-8 - xOffset}px`
      } else if (this.arrowRightSide || this.arrowLeftSide) {
      } else {
        result.left = isLeft ? `${-13 + xOffset}px` : 'auto'
        result.right = !isLeft ? `${-13 + xOffset}px` : 'auto'
      }

      if (this.bindedArrowTop) {
        result.paddingBottom = '15px'
      }
      return result
    },
    getBrowserInfo () {
      return 'browser-' + browserInfo.name
    }
  }
}
</script>

<style lang="scss">
.tooltip {
  position: relative;
  display: inline-block;
  vertical-align: top;

  & /deep/ .bubble {
    z-index: 15;
    .text {
      text-align: left;
    }
  }
}
</style>
